<template>
  <vs-row vs-justify="center" class="mt-0">
    <vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <div style="display: flex; flex-direction: column">
        <label class="mb-2">Select App</label>
        <vs-select v-model="selectedApp" @change="handleAppSelect()">
          <vs-select-item value text="Select App" disabled />
          <vs-select-item value="all" text="All" />
          <vs-select-item :key="index" :value="item._id" :text="item.title + ' (' + item.language + ')'" v-for="(item, index) in allApps" />
        </vs-select>
      </div>
      <div class="tabOptions" v-if="selectedApp && selectedApp !== 'all'">
        <button :class="{ active: activeTab === 'reviewsList' }" @click="switchTab('reviewsList')" color="primary" class="mr-2">Reviews List</button>
        <button :class="{ active: activeTab === 'responses' }" @click="switchTab('responses')" color="primary" class="mr-2">Autoreply Config</button>
      </div>
    </vs-col>
    <vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12" v-if="selectedApp && selectedApp !== 'all'">
      <div v-if="activeTab === 'responses'">
        <PredefinedResponses :selectedAppForConfig="selectedAppForConfig" />
      </div>
      <div v-if="activeTab === 'reviewsList'">
        <ReviewList :selectedAppForConfig="selectedAppForConfig" />
      </div>
    </vs-col>

    <vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12" v-else-if="selectedApp === 'all'">
      <AllReviewList :allReviews="allReviews" :getAllReviewsList="getAllReviewsList" :totalPages="totalPages" />
    </vs-col>
  </vs-row>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
import PredefinedResponses from "../../components/PredefinedResponses.vue";
import ReviewList from "../../components/ReviewList.vue";
import AllReviewList from "../../components/AllReviewList.vue";

export default {
  name: "appReviews",
  components: {
    PredefinedResponses,
    ReviewList,
    AllReviewList,
  },
  data: () => ({
    title: "App Reviews",
    activeTab: "reviewsList",
    selectedAppForConfig: {},
    selectedApp: "",
    allApps: [],
    allReviews: [],
    totalPages: 0,
  }),
  methods: {
    async fetchAllApps() {
      this.$vs.loading();
      try {
        const res = await api.get(`${API.GET_APP}?language=all`);
        if (res.status == 200) this.$data.allApps = res.data;
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error while fetching apps",
          color: "danger",
          position: "top-right",
        });
        console.log(error);
      } finally {
        this.$vs.loading.close();
      }
    },

    switchTab(tab) {
      this.activeTab = tab;
    },

    async handleAppSelect() {
      if (this.selectedApp === "all") await this.getAllReviewsList();
      else await this.getAutoReviewData();
    },

    async getAllReviewsList(currentPage, limit, filters) {
      if (!filters || !currentPage || !limit) return;
      const page = !isNaN(currentPage) && currentPage > 0 ? currentPage : 1;

      this.$vs.loading();
      try {
        const res = await api.get(
          `${API.GET_REVIEWS}/getAllReviews?rating=${filters.showStars}&resolved=${filters.showResolved}&page=${page}&limit=${limit}`
        );

        if (res.status == 200) {
          res.data.data.sort((a, b) => {
            return a.reviewCreatedAt.seconds - b.reviewCreatedAt.seconds;
          });
          this.$data.allReviews = res.data.data;
          this.totalPages = Math.ceil(res.data.total / limit);
          console.log("Total items:", res.data.total);
          console.log("Limit:", limit);
          console.log("Total pages:", this.totalPages);
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error while fetching reviews",
          color: "danger",
          position: "top-right",
        });
        console.log(error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async getAutoReviewData() {
      this.$vs.loading();
      try {
        const packageName = this.allApps.find((app) => app._id === this.selectedApp).bundleId;

        const res = await api.get(`${API.GET_REVIEWS}?packageName=${packageName}`, {});
        if (res.status == 200) {
          this.$data.selectedAppForConfig = Object.assign({}, res.data);
          console.log(this.$data.selectedAppForConfig);
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error while fetching reviews",
          color: "danger",
          position: "top-right",
        });
        console.log(error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },

  async created() {
    await this.fetchAllApps();
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}
.flex-grow {
  flex-grow: 1;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.ml-2 {
  margin-left: 0.5rem;
}

.tabOptions {
  display: flex;
  font-size: larger;
  font-weight: bolder;
}

.tabOptions button {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 10px 20px;
  cursor: pointer;
  margin-right: 10px;
  transition: all 0.3s ease;
}

.tabOptions button.active {
  border-bottom: 2px solid #007bff; /* Color for the active tab */
  color: #007bff; /* Text color for the active tab */
}

.tabOptions button:hover {
  color: #0056b3; /* Text color on hover */
}

.tabOptions button:focus {
  outline: none; /* Remove default outline on focus */
}
</style>
